import klineStyle from '../echartsOption/klineStyle';

/**
 * 定义计算MACD类
 */
class MACD {
    /**
     * 计算MACD类构造函数
     * @param {Array<Number>} closes 收盘价集合
     * @param {Number} m m参数
     * @param {Number} n n参数
     * @param {Number} k k参数
     */
    constructor(closes, m = 12, n = 26, k = 9) {
        this.closes = closes || [];
        this.m = m;
        this.n = n;
        this.k = k;
        this.ema = {};
        this.ema[m] = [];
        this.ema[n] = [];
        this.difs = [];
        this.deas = [];
        this.macds = [];

        this.seriesOptions = ['DIF', 'DEA'].map(name => {
            return {
                name,
                type: 'line',
                data: [],
                xAxisIndex: 3,
                yAxisIndex: 3,
                showSymbol: false,
                lineStyle: {
                    width: 1
                }
            };
        });
        this.seriesOptions.push({
            name: 'MACD',
            type: 'bar',
            xAxisIndex: 3,
            yAxisIndex: 3,
            showSymbol: false,
            data: [],
            itemStyle: {
                normal: {
                    color: function(params) {
                        // 因为borderColor不支持function，无法实现动态的空心柱状图，所以注释掉无用代码
                        // var lastValue = data.macds[Math.max(params.dataIndex - 1, 0)];
                        // if(params.data > lastValue) {
                        //     return 'transparent';
                        // } else {
                        if (params.data >= 0) {
                            return klineStyle.lineColor.color;
                        } else {
                            return klineStyle.lineColor.color0;
                        }
                        // }
                    }
                    // 因为borderColor不支持function，无法实现动态的空心柱状图，所以注释掉无用代码
                    // borderColor(params) {
                    //     if (params.data >= 0) {
                    //         return klineStyle.lineColor.borderColor;
                    //     } else {
                    //         return klineStyle.lineColor.borderColor0;
                    //     }
                    // }
                }
            }
        });
    }

    /**
     * 从指定索引开始，一直计算到最后一个所有与MACD有关的值，并更新类的属性
     * @param {Number} i 指定的索引
     */
    calculate(i = 0) {
        this.ema[this.m] = [];
        this.ema[this.n] = [];
        this.difs = [];
        this.deas = [];
        this.macds = [];
        for (; i < this.closes.length; i++) {
            const close = this.closes[i];

            this.ema[this.m][i] = this.calculateEMA(i, this.m, close);
            this.ema[this.n][i] = this.calculateEMA(i, this.n, close);
            this.difs[i] = this.calculateDIF(i);
            this.deas[i] = this.calculateDEA(i, close);
            this.macds[i] = this.calculateMACD(i);
        }
    }

    /**
     * 计算EMA值
     * @param {Number} index 索引
     * @param {Number} base 基数
     * @param {Number} close 收盘价
     * @returns {Number} 返回计算后的EMA值
     */
    calculateEMA(index, base, close) {
        if (index === 0) {
            return close;
        }
        return (
            (2 / (base + 1)) * close +
            ((base - 1) / (base + 1)) * this.ema[base][index - 1]
        );
    }

    /**
     * 计算DIF值
     * @param {Number} i 索引
     * @returns {Number} 返回计算后的DIF值
     */
    calculateDIF(i) {
        return this.ema[this.m][i] - this.ema[this.n][i];
    }

    /**
     * 计算DEA值
     * @param {Number} i 索引
     * @param {Number} close 收盘价
     * @returns {Number} 返回计算后的DEA值
     */
    calculateDEA(i, close) {
        if (i === 0) {
            // return close;    // 如果用收盘价的话，第一个MACD值会变成2倍的close
            return 0;
        }
        return (
            (2 / (this.k + 1)) * this.difs[i] +
            ((this.k - 1) / (this.k + 1)) * this.deas[i - 1]
        );
    }

    /**
     * 计算MACD值
     * @param {Number} i 索引
     * @returns {Number} 返回计算后的MACD值
     */
    calculateMACD(i) {
        return 2 * (this.difs[i] - this.deas[i]);
    }

    /**
     * 生成Series选项
     * @returns {Object} 返回生成的echarts的option对象
     */
    generateSeriesOption() {
        this.seriesOptions.forEach(option => {
            let key = option.name.toLowerCase() + 's';
            option.data = this[key];
        });
        return this.seriesOptions;
    }
}

export default MACD;



// WEBPACK FOOTER //
// ./src/controller/series/MACD.js